import { SVGFC } from '@repo/toolkit/types'

const MeetingIcon: SVGFC = ({ color = 'white', ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.73586 10.4693C6.43593 10.4693 7.00345 9.90175 7.00345 9.20168C7.00345 8.5016 6.43593 7.93408 5.73586 7.93408C5.03578 7.93408 4.46826 8.5016 4.46826 9.20168C4.46826 9.90175 5.03578 10.4693 5.73586 10.4693Z"
        strokeWidth="0.6"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.06724 11.0981L6.74604 12.7612H8.79959C9.07131 12.7612 9.2916 12.9815 9.2916 13.2532C9.2916 13.5249 9.07131 13.7452 8.79959 13.7452H6.50701C6.35669 13.7452 6.20973 13.7007 6.08467 13.6173C5.95961 13.5339 5.86204 13.4153 5.80427 13.2765L5.28301 12.0119M3.77783 14.4616L3.86801 12.4353C3.92534 11.5727 4.22833 10.7444 4.74118 10.0483"
        strokeWidth="0.6"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3643 10.4693C19.0643 10.4693 19.6319 9.90175 19.6319 9.20168C19.6319 8.5016 19.0643 7.93408 18.3643 7.93408C17.6642 7.93408 17.0967 8.5016 17.0967 9.20168C17.0967 9.90175 17.6642 10.4693 18.3643 10.4693Z"
        strokeWidth="0.6"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0329 11.0981L17.3542 12.7612H15.3006C15.0289 12.7612 14.8086 12.9815 14.8086 13.2532C14.8086 13.5249 15.0289 13.7452 15.3006 13.7452H17.5932C17.7435 13.7452 17.8905 13.7007 18.0155 13.6173C18.1406 13.5339 18.2382 13.4153 18.2959 13.2765L18.8172 12.0119M20.3224 14.4616L20.2322 12.4353C20.1748 11.5727 19.8719 10.7444 19.359 10.0483"
        strokeWidth="0.6"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0236 6.64684C12.6402 6.64684 13.14 6.14701 13.14 5.53045C13.14 4.91389 12.6402 4.41406 12.0236 4.41406C11.4071 4.41406 10.9072 4.91389 10.9072 5.53045C10.9072 6.14701 11.4071 6.64684 12.0236 6.64684Z"
        strokeWidth="0.6"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0643 9.93033L13.8526 8.46312C13.85 8.44678 13.8472 8.43049 13.8441 8.41425C13.727 7.80858 13.183 7.37939 12.5662 7.37939H11.4928C10.876 7.37939 10.332 7.80862 10.2149 8.41425C10.2118 8.43046 10.209 8.44674 10.2064 8.46312L9.98242 9.99945"
        strokeWidth="0.6"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0236 15.1898C12.6402 15.1898 13.14 14.69 13.14 14.0734C13.14 13.4569 12.6402 12.957 12.0236 12.957C11.4071 12.957 10.9072 13.4569 10.9072 14.0734C10.9072 14.69 11.4071 15.1898 12.0236 15.1898Z"
        strokeWidth="0.6"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8527 17.0061C13.8501 16.9897 13.8473 16.9735 13.8442 16.9572C13.7271 16.3516 13.1832 15.9224 12.5663 15.9224H11.4929C10.8761 15.9224 10.3321 16.3516 10.2151 16.9572C10.2119 16.9734 10.2091 16.9897 10.2065 17.0061"
        strokeWidth="0.6"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.24621 19.6489L8.37042 18.3535C8.43954 17.6327 9.04503 17.0825 9.76908 17.0825H14.3865C15.0961 17.0825 15.6942 17.6115 15.781 18.3157L15.9454 19.6489M16.8946 11.5278L16.4026 10.5561C16.3287 10.4047 16.2139 10.2771 16.071 10.1879C15.9282 10.0986 15.7631 10.0513 15.5947 10.0513H8.31695C8.13977 10.0513 7.96654 10.1036 7.81903 10.2018C7.67153 10.2999 7.55632 10.4395 7.48789 10.6029L7.12125 11.4575M16.4624 17.188H18.8851C19.2323 17.188 19.4595 16.8244 19.3073 16.5123L18.3292 14.5066M5.82043 14.5066L5.00326 16.5368C4.87364 16.8463 5.10099 17.188 5.4366 17.188H7.75476"
        strokeWidth="0.6"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default MeetingIcon
